import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { openWhatsAppWithMessage } from "../../../constants/whatsappContact";
import "./WhatsAppFloat.css";

const WhatsAppFloat = ({ productInfo }) => {
  const handleWhatsAppClick = () => {
    let message =
      `Hi! I'm interested in your products. Can you help me with more information?`;

    if (productInfo && productInfo.name) {
      message = `Hi! I'm interested in this product: ${productInfo.name}`;
      if (productInfo.url) {
        message += `\nProduct Link: ${productInfo.url}`;
      }
      message += "\nCan you provide more details about this product?";
    }

    openWhatsAppWithMessage(message);
  };

  return (
    <div className="whatsapp-float" onClick={handleWhatsAppClick}>
      <FaWhatsapp className="whatsapp-icon" />
    </div>
  );
};

export default WhatsAppFloat;
